<div style="border-top: 1px solid #000; margin-top: 30px; padding-top: 30px;">

  <div fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout="row wrap">
    <div *ngFor="let productGroup of productGroups" class="product-group-box">
      <p><a href="/areas/{{ restaurant.AreaId }}/restaurants/{{ restaurantId }}/product/groups/{{ productGroup.Id }}">{{ productGroup.Name }}</a></p>
      <div style="width: 100%">
        <!-- <img rel="preload" as="image" src="" style="object-fit: cover; width: 100%; height: 150px;"> -->
      </div>
    </div>
  </div>


</div>

